module.exports = __webpack_public_path__ + "static/favicon-480adf6d2ae3adf2b2d67c6e56681920.ico";